<h1 class="nuestros-productos-d">
    {{copyService.copies.request_Subtitle}}
</h1>
<div class="content-with-filled-button">
    <form [formGroup]="formGroup">
        <div *ngFor="let row of list_multi">
            <h1 class="tarjetas" *ngIf="row.type === 'title'  && row.show">{{row.value}}</h1>
            <div [ngClass]="this.loan ? 'background-active': background"
                *ngIf="row.type === 'alert'&& this.loan">
                <voxel-icon class="ico">informacao_outline</voxel-icon>
                <p [ngClass]="this.loan ? 'text': text-none">
                    {{row.value}}
                </p>
            </div> 
            <div class="group-5" [ngClass]="opacityChange(row.flow)" *ngIf="row.type === 'checkbox' && row.show">
                <voxel-form-selection class="mb-3 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4 col-lg-4">
                    <div class="field col-8 col-sm-8 col-md-8 col-lg-8 col-xl-8 px-0">
                        <voxel-checkbox  [formControlName]="row.flow" [id]="row.flow" [value]="row.flow" [name]="row.flow" >
                        </voxel-checkbox>
                        <label class="label">{{row.name}}</label>
                        <div class="link">
                            <p >{{row.subTitle}}</p>
                            <a (click)="goToProductDetails(row.flow, 'ConoceMas')" class="linkText">{{copyService.copies.product_selection_product_detail}}</a>
                        </div>
                    </div>
                </voxel-form-selection>
            </div>
            
        </div>

    </form>
</div>
<br><br>
<app-controls id="button-process" [hasPrevious]="true"
    [nextLabel]="copyService.copies.product_selection_go_step_process_soli" [nextDisabled]="!statusValidation" (next)="next()"></app-controls>